export default __webpack_public_path__ + "static/media/sitting_man_pers.7061fed5.svg";